import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { JarwisService } from './../../services/jarwis.service';
import { User } from './../../models/user';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public loggedIn: boolean;
  UserProfile: User;
  constructor(
    private Auth: AuthService,
    private router: Router,
    private Token: TokenService,
    public jarwisService: JarwisService,
  ) { }

  ngOnInit() {
    this.Auth.authStatus.subscribe(async value => {
      this.loggedIn = value

      if (this.loggedIn) {
        this.UserProfile = await this.jarwisService.profileUser()
      }
    });
  }

  logout(event: MouseEvent) {
    event.preventDefault();
    this.Token.remove();
    this.Auth.changeAuthStatus(false);
    this.router.navigateByUrl('/login');
  }

}